/**
 * StudentHomeScreen — l'onglet Accueil de l'espace élève (`<StudentHomePage>`).
 *
 * Un fil : les lectures et le premier affichage (`useStudentHomeData`), le store mis en forme
 * (`studentHomeViewModel`), les gestes (`useStudentHomeState`), la demande de note du store. Le
 * prochain contrôle est le widget des contrôles, branché dans sa fente ; « GO ! », et une ligne d'un
 * live suivant, ouvrent `pre-call` ou la boîte qui dit pourquoi pas (`<LiveAccessDialog>`).
 */
import React from "react"
import { useSelector } from "react-redux"

import { LiveAccessDialog, NextSchoolAssessmentCard, StudentHomePage } from "../../../../../../design-system/student"
import { studentHomeViewModel } from "../../../../view-models/student/Home/studentHomeViewModel"
import { useStudentHomeData } from "./useStudentHomeData"
import { useStudentHomeState } from "./useStudentHomeState"
import { useStudentHomeStoreReview } from "./useStudentHomeStoreReview"

export function StudentHomeScreen() {
    const vm = useSelector(studentHomeViewModel)
    const { refresh, firstDisplayLoading } = useStudentHomeData(vm)
    const home = useStudentHomeState(vm)
    useStudentHomeStoreReview()

    return (
        <>
            <StudentHomePage
                {...vm}
                {...home}
                loading={firstDisplayLoading}
                assessmentSlot={
                    <NextSchoolAssessmentCard
                        assessment={vm.assessment}
                        loading={vm.assessmentLoading}
                        onOpenAssessments={home.onOpenAssessments}
                    />
                }
                onRetry={refresh}
            />
            <LiveAccessDialog
                notice={home.notice}
                session={home.noticeSession ?? vm.nextSession}
                onClose={home.closeNotice}
                onSettlePayment={home.onSettlePayment}
            />
        </>
    )
}
